import { Popover, Space, Typography } from "antd";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CaretDownIcon } from "../../../common/images/svg/CaretDown.svg";
import { ReactComponent as DepositIcon } from "../../../common/images/svg/HandDeposit.svg";
import { ReactComponent as WithDrawIcon } from "../../../common/images/svg/HandWithdraw.svg";
import { ReactComponent as WalletIcon } from "../../../common/images/svg/Wallet.svg";
import { CustomButton } from "../../../components/button/buttonCustom";
import { useNotification } from "../../../components/providers/notification/useNotification";
import { convertCurrency } from "../../../utils/hooks/convertRate";
import useResponsive from "../../../utils/hooks/useResponsive";
import { formatNumber } from "../../../utils/list.utils";
import CurrencyOption from "./currencyOption";
import "./option.css";

export const ThemedOption: React.FC<any> = ({
  currencyOption,
  setCurrencyOption,
  canAction,
  totalAsset,
  rates,
}: {
  currencyOption: string;
  setCurrencyOption: React.Dispatch<React.SetStateAction<string>>;
  canAction: boolean;
  totalAsset: number;
  rates: {
    EUR: string;
    ETH: string;
    DAI: string;
    USDT: string;
    USD: string;
  };
}) => {
  const { isTablet } = useResponsive();
  const navigate = useNavigate();
  const [openOption, setOpenOption] = useState(false);
  const { open: openNotification } = useNotification();

  const onOpenChange = useCallback((open: boolean) => {
    setOpenOption(open);
  }, []);

  const handleSendMoney = () => {
    if (canAction) navigate(`/send-money`);
    else {
      if (openNotification) {
        openNotification?.({
          key: "not_permission",
          message:
            "Your account is currently under review by the admin. You will be able to use this feature once the review is complete and your account is verified.",
          type: "error",
        });
      }
    }
  };

  const handleReceiveMoney = () => {
    if (canAction) navigate(`/request-money`);
    else {
      if (openNotification) {
        openNotification?.({
          key: "not_permission",
          message:
            "Your account is currently under review by the admin. You will be able to use this feature once the review is complete and your account is verified.",
          type: "error",
        });
      }
    }
  };

  return (
    <Space className={"box-option"}>
      <Space className={"box-assets"}>
        <div className={"box-wallet"}>
          <WalletIcon />
          <Typography style={{ color: "white", fontSize: 14 }}>
            Total Assets
          </Typography>
        </div>
        <div className={"amount-wallet"}>
          <Typography style={{ color: "white", fontSize: 32, fontWeight: 700 }}>
            {currencyOption === "USD"
              ? formatNumber(totalAsset, 2)
              : formatNumber(
                  convertCurrency(totalAsset, "USD", "EUR", rates),
                  2
                )}
          </Typography>
          <Popover
            content={
              <CurrencyOption
                setOpenOption={setOpenOption}
                setCurrencyOption={setCurrencyOption}
                currencyOption={currencyOption}
              />
            }
            trigger="click"
            arrow={false}
            overlayInnerStyle={{ borderRadius: "2px", padding: 0 }}
            placement={"bottom"}
            open={openOption}
            onOpenChange={onOpenChange}
          >
            <div className="popover-currency">
              <Typography className="popover-text-currency">
                {currencyOption}
              </Typography>
              <CaretDownIcon style={{ width: 16, height: 16 }} />
            </div>
          </Popover>
        </div>
      </Space>
      <Space className={"list-option"}>
        <CustomButton
          size={isTablet ? "small" : "medium"}
          icon={<DepositIcon />}
          text={"Send Money"}
          onClick={handleSendMoney}
        />
        <CustomButton
          size={isTablet ? "small" : "medium"}
          icon={<WithDrawIcon />}
          text={"Request Money"}
          onClick={handleReceiveMoney}
        />
      </Space>
    </Space>
  );
};
